import React from "react"
import Logo from './rijksoverheid.png'
import './style.css'

class Header extends React.Component {
    render() {
        return (
            <header className="header">
                <a href="#inhoud" className="skiplink">Direct naar de inhoud</a>
                <a href="https://www.komveiligthuis.nl/">
                    <img height="100" width="50" alt="Logo Rijksoverheid - Naar de homepage van komveiligthuis.nl" src={Logo} />
                </a>

                <div className="breadcrumbs">
                    <div className="container">
                        <ul>
                            <li><a href="https://www.komveiligthuis.nl/">Kom veilig Thuis</a></li>
                            <li><a href="https://www.komveiligthuis.nl/fietshelm">Fietshelm</a></li>
                            <li><a href="https://www.komveiligthuis.nl/fietshelm/over-de-campagne">Over de campagne</a></li>
                            <li><span>Maak je eigen Zet ‘m op poster</span></li>
                        </ul>
                    </div>
                </div>

            </header>
        )
    }
}

export default Header